export const handlerCSS: Function = (obj: object) => {
  let hasOwnProperty = Object.prototype.hasOwnProperty;
  for (let prop in obj) {
    if (hasOwnProperty.call(obj, prop)) {
      // @ts-ignore
      document.documentElement.style.setProperty(`--${prop}`, obj[prop]);
    }
  }
};
